import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import {
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileBest3Card',
  props: {
    currentCardId: null,
    formatId: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
};



const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

function hobbyItem(idx: number) {
  return stringListItem(formatData.hobbies, idx)
}

function setHobby(idx: number, val: string) {
  setStringListItem(formatData, 'hobbies', idx, val, 3)
}

function skillItem(idx: number) {
  return stringListItem(formatData.skills, idx)
}

function setSkill(idx: number, val: string) {
  setStringListItem(formatData, 'skills', idx, val, 3)
}

return { __sfc: true,props, formatData, isSection, hobbyItem, setHobby, skillItem, setSkill }
}

})